import React,{ useCallback,useMemo } from "react";
import { useSelector,useDispatch } from "react-redux";
import { SetSliderValueMinMax,SetUrlPrefix,SetImgPrefix,SetSliderValue,SetIsExpanded,SetIsSearching,SetSearchWord,SetPrevProducts,SetAsyncData,
  SetListingBanner,SetProducts,SetFilters,SetResultsCount,SetMasterCategories,SetPages,SetPage,SetSuggestedWords } from "../../state/actions/index";
import './SuggestedWords.css';
import Utils from "../../utils/Utils";
import axios from 'axios';

const SuggestedWords = () => {
  const suggestedWords = useSelector(state => state.suggestedWords);
  const configFilters = useSelector(state => state.config.filters);
  const card = useSelector(state => state.config.card);
  const activeFilters = useSelector(state => state.activeFilters);
  const filters = useSelector(state => state.config.filters);
  const suggestedWordsPlaceholder = useSelector(state => state.config.placeholders.suggestedWords);
  const sliderValue = useSelector(state => state.sliderValue);
  const sliderValueMinMax = useSelector(state => state.sliderValueMinMax);
  const defaultMasterCategories = useSelector(state => state.defaultMasterCategories);
  const config = useSelector(state => state.config);
  const isMobile = useSelector(state => state.isMobile);
  const products = useSelector(state => state.products);
  const sort = useSelector(state => state.sort)
  const dispatch = useDispatch();

  const queryOptions = useSelector(state => state.config.queryOptions);
  var rows=useMemo(()=>isMobile?queryOptions.rows.mobile:queryOptions.rows.desktop,[isMobile,queryOptions]);

  const categoryKey=useMemo(()=>{
    var valueToReturn=""; 
    Object.keys(configFilters).forEach(filter=>{
      if(configFilters[filter].isCategory) valueToReturn=filter
    })
    return valueToReturn;
  },[configFilters])

  const onWordClick = useCallback((word) => {
    dispatch(SetSearchWord(word));
    dispatch(SetIsSearching(true));
    dispatch(SetAsyncData([]));
    var priceGroup={}
    priceGroup.id=window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType?window.AS_ADVANCED_CONFIG.visitorType:config.priceGroup.id;
    priceGroup.currency=window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode?window.AS_ADVANCED_CONFIG.currencyCode:config.priceGroup.currency;
    var localSearchUrl=Utils.getSearchUrl(config.baseUrl,config.queryOptions,priceGroup,config.shopId,config.jsonFast);
    axios.get(Utils.insertWordInSearchUrl(localSearchUrl,word,activeFilters,sort,1,filters,rows))
    .then(res=>{
        var response=res.data;
        dispatch(SetIsExpanded({}));
        dispatch(SetPrevProducts(products));
        dispatch(SetProducts(Utils.refactorUrl(response.data,response.header.imagePrefix,response.header.urlPrefix,card.img,card.url)));
        dispatch(SetSuggestedWords(response.suggestions));
        dispatch(SetResultsCount(response.header.results_count));
        dispatch(SetSliderValue(Utils.addSliderValue(response,sliderValue)));
        dispatch(SetSliderValueMinMax(Utils.addSliderValue(response,sliderValueMinMax)));
        dispatch(SetFilters(response));
        dispatch(SetPages(parseInt((response.header.results_count-1)/rows)+1));
        dispatch(SetPage(1));
        dispatch(SetListingBanner(response.banners[0]));
        dispatch(SetMasterCategories(response.stats[categoryKey]?Utils.refactorMasterCategories(Object.keys(response.stats[categoryKey])):defaultMasterCategories)); 
        dispatch(SetUrlPrefix(response.header.urlPrefix));
        dispatch(SetImgPrefix(response.header.imagePrefix));
        if(config.webhook.key!=='') Utils.getAsyncData(config.webhook,response.data,priceGroup).then(value=>dispatch(SetAsyncData(value.asyncData)));
      })
      .finally(()=>dispatch(SetIsSearching(false)))
  },
    [dispatch, activeFilters, defaultMasterCategories, rows,sort,sliderValue,sliderValueMinMax,config,filters,products,categoryKey,card]);
  
  return(
    <div className="suggested-words"> 
      <div className="label"> {suggestedWordsPlaceholder} </div> 
      <div className="suggested-words-list">
        { suggestedWords.map((item,index)=>
          <span className={"item"+(index===suggestedWords.length-1?' last':'')} key={'suggested_word_'+index} onClick={()=>onWordClick(item)}> {item} </span> 
        )}
      </div>
    </div>
  )
};

export default SuggestedWords;